export enum AnalyticsFiltersEnum {
  INCLUDE_ADMINS = 'INCLUDE_ADMINS',
  INCLUDE_ARCHIVED = 'INCLUDE_ARCHIVED',
  INCLUDE_DRAFTS = 'INCLUDE_DRAFTS',
  DATE_FILTER = 'DATE_FILTER',
  GROUP_FILTER = 'GROUP_FILTER',
  WORKSPACE_FILTER = 'WORKSPACE_FILTER',
  PATHWAY_FILTER = 'PATHWAY_FILTER',
  CAMPAIGN_FILTER = 'CAMPAIGN_FILTER'
}
